export enum ESecurityFlag {
	authenticated = "authenticated"
}